module.exports = __webpack_public_path__ + "Server-CalamariNeedsUpgrade-Ssh.feddeb4c92298fd746d963138a92486a.hashedasset.svg";